"use client";

import { XCircleIcon } from "lucide-react";
import { Button } from "~/components/ui/button";

export interface PaymentErrorStateProps {
  title?: string;
  errorMessage?: string;
  helperText?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function PaymentErrorState({
  title = "Plaćanje nije uspelo",
  errorMessage = "Plaćanje nije uspelo. Pokušaj ponovo.",
  helperText = "Sesija nije zakazana i ništa nije naplaćeno. Možeš ispod proveriti podatke i pokušati ponovo.",
  actionLabel,
  onAction,
}: PaymentErrorStateProps) {
  return (
    <div
      className="rounded-lg border border-red-200 bg-red-50 p-4"
      role="alert"
      aria-live="assertive"
    >
      <div className="flex items-start gap-3">
        <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" />
        <div className="flex-1 space-y-2">
          <p className="text-sm font-medium text-red-800">{title}</p>
          <p className="text-sm text-red-700">{errorMessage}</p>
          <p className="text-xs text-red-600">{helperText}</p>
          {actionLabel && onAction ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="border-red-300 bg-background text-red-800 hover:bg-red-100"
              onClick={onAction}
            >
              {actionLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
